import { render, staticRenderFns } from "./NotificationTable.vue?vue&type=template&id=ea742498&scoped=true"
import script from "./NotificationTable.vue?vue&type=script&lang=js"
export * from "./NotificationTable.vue?vue&type=script&lang=js"
import style0 from "./NotificationTable.vue?vue&type=style&index=0&id=ea742498&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea742498",
  null
  
)

export default component.exports